import { Icon, Row, Text } from "components";

import ProgressBar from "components/ProgressBar";
import colors from "utils/colors";
import styled from "styled-components";

/**
 * Non‑functional demo component that visually showcases collaborative review
 * progress (e.g. "2 / 4 approvals complete"). Intended purely for pitch/demo.
 */
export default function CollaborativeReviewProgress() {
  // Mock data – replace with real values when wiring up
  const reviewers = [
    {
      id: 1,
      name: "Alice",
      team: "Finance",
      status: "approved",
      thumbnail:
        "https://res.cloudinary.com/frontly/image/upload/v1661294841/users/user-6_qwd0kq.png",
    },
    {
      id: 2,
      name: "Bob",
      team: "Finance",
      status: "pending",
      thumbnail:
        "https://res.cloudinary.com/frontly/image/upload/v1661294841/users/user-2_h1jmvr.png",
    },
    {
      id: 3,
      name: "Carlos",
      team: "Marketing",
      status: "approved",
      thumbnail:
        "https://res.cloudinary.com/frontly/image/upload/v1661294841/users/user-8_elpuxb.png",
    },
    {
      id: 4,
      name: "Dana",
      team: "Marketing",
      status: "pending",
      thumbnail:
        "https://res.cloudinary.com/frontly/image/upload/v1661294841/users/user-7_mnchtw.png",
    },
  ];

  const completed = reviewers.filter((r) => r.status === "approved").length;
  const total = reviewers.length;
  const percent = (completed / total) * 100;

  return (
    <Card>
      <Text
        data={{
          text: "Trip Itinerary - Draft 1",
          fontSize: 24,
          fontWeight: 700,
          margin: "0 0 20px 0",
        }}
      />
      <Header>
        <Text
          data={{ text: "Approval Progress", fontSize: 20, fontWeight: 700 }}
        />
        <Text
          data={{
            text: `${completed} / ${total} complete`,
            fontSize: 16,
            fontWeight: 500,
            color: colors.primary,
          }}
        />
      </Header>

      {/* Progress bar */}
      <ProgressBarWrapper>
        <ProgressBar percent={percent} />
      </ProgressBarWrapper>

      {/* Reviewer list */}
      {reviewers.map((r) => (
        <ReviewerRow key={r.id} $status={r.status}>
          <Row $alignitems="center" $gap="10px">
            <Thumbnail src={r.thumbnail} />
            <Text data={{ text: r.name, fontSize: 16, fontWeight: 600 }} />
            <TeamPill>{r.team}</TeamPill>
          </Row>
          {r.status === "approved" ? (
            <Icon
              data={{ icon: "FiCheckCircle", color: "#30b66f", size: 20 }}
            />
          ) : (
            <Icon data={{ icon: "FiClock", color: colors.grey, size: 20 }} />
          )}
        </ReviewerRow>
      ))}
    </Card>
  );
}

/* --------------------------------- Styles -------------------------------- */
const Card = styled.div`
  border: 1px solid ${colors.inputBorder};
  border-radius: 12px;
  padding: 24px;
  background: #fff;
  max-width: 600px;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  border-top: 1px solid ${colors.inputBorder};
  padding-top: 20px;
`;

const ProgressBarWrapper = styled.div`
  margin-bottom: 20px;
`;

const ReviewerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-top: 1px solid ${colors.inputBorder};

  &:first-of-type {
    border-top: none;
  }

  ${(p) =>
    p.$status === "approved" &&
    `
    background: #f6fbf8;
  `}
`;

const TeamPill = styled.span`
  background: ${colors.lightGrey};
  color: white;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 999px;
`;

const Thumbnail = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 999px;
`;
